/**
 * COMPTABILITÉ — L'ADRESSE DE LA LISTE DES SOURCES, FILTRÉE PAR FOURNISSEUR.
 *
 * Les tuiles ZAP et Shotgun de l'accueil mènent à la liste des documents
 * reçus, filtrée sur leur fournisseur (`?fournisseur=ZAP_SIS`). Le nom du
 * paramètre et ses valeurs vivent ICI, une seule fois : l'accueil fabrique
 * l'adresse, l'écran des sources la relit, et aucun des deux ne recopie la
 * convention de l'autre.
 *
 * Module SANS effet de bord (ni `window`, ni React, ni feuille de style) :
 * il se teste tel quel, hors navigateur.
 */

import type { SourceProvider } from './ClosingCommon.js'

/** Les fournisseurs admis en base (miroir de `SOURCE_PROVIDER_LABELS`). */
export const FOURNISSEURS: readonly SourceProvider[] = ['ZAP_SIS', 'SHOTGUN', 'MANUEL', 'AUTRE']

/**
 * Le fournisseur demandé par l'adresse. Le code canonique (`ZAP_SIS`) et le
 * nom court qu'on tape à la main (`zap`, `shotgun`) désignent le même
 * filtre ; tout le reste est IGNORÉ plutôt que de filtrer sur un fournisseur
 * qui n'existe pas — une liste vide aurait l'air d'une absence de documents.
 */
export function fournisseurDepuis(brut: string | null): SourceProvider | null {
  if (brut === null) return null
  const v = brut.trim().toUpperCase()
  if (v === 'ZAP') return 'ZAP_SIS'
  return (FOURNISSEURS as readonly string[]).includes(v) ? (v as SourceProvider) : null
}

/**
 * La liste d'un fournisseur, TOUTES VUES CONFONDUES (`vue=tout`) : la vue par
 * défaut, « à vérifier », est vide la plupart du temps, et la tuile de
 * l'accueil semblerait ne mener nulle part.
 */
export function adresseSources(fournisseur: SourceProvider): string {
  return `/comptabilite/sources?vue=tout&fournisseur=${fournisseur}`
}
